// eslint-disable-next-line import/no-named-as-default
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./common/en.json";
import translationKa from "./common/ka.json";
import translationUk from "./common/uk.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  ka: {
    translation: translationKa,
  },
  uk: {
    translation: translationUk,
  },
};

// eslint-disable-next-line import/no-named-as-default-member
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: ["ka", "en", "uk"], // use en if detected lng is not available
    detection: {
      order: ["path", "navigator"],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
